/* Warehouse Gear Hub — collection page behaviours.
   Plain deferred script, loaded by the product grid and the header. Guarded
   so a second <script> tag on the same page is a no-op.

   What lives where (README "State management"):
     filters / sort ............ URL (server-rendered; this file only submits the form)
     grid / list view .......... localStorage  wgh_view
     facet open state .......... sessionStorage wgh_facets
     compare selection (≤4) .... localStorage  wgh_compare
     quote list ................ localStorage  wgh_quote  (no quote app installed —
                                 the list is handed to the theme's RFQ popup)
     cart count ................ the theme's <cart-counter>, via its updateCart event
*/
(function () {
  if (window.__wghCollection) return;
  window.__wghCollection = true;

  const COMPARE_KEY = 'wgh_compare';
  const QUOTE_KEY = 'wgh_quote';
  const VIEW_KEY = 'wgh_view';
  const FACET_KEY = 'wgh_facets';
  const MAX_COMPARE = 4;

  const $ = (sel, root) => (root || document).querySelector(sel);
  const $$ = (sel, root) => Array.from((root || document).querySelectorAll(sel));

  const store = {
    get(key, session) {
      try {
        const raw = (session ? sessionStorage : localStorage).getItem(key);
        return raw ? JSON.parse(raw) : null;
      } catch (e) { return null; }
    },
    set(key, value, session) {
      try { (session ? sessionStorage : localStorage).setItem(key, JSON.stringify(value)); } catch (e) { /* private mode */ }
    }
  };

  const icon = (name, size) => {
    const paths = {
      check: '<path d="M20 6 9 17l-5-5"/>',
      x: '<path d="M18 6 6 18"/><path d="m6 6 12 12"/>',
      'triangle-alert': '<path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3"/><path d="M12 9v4"/><path d="M12 17h.01"/>',
      trash: '<path d="M3 6h18"/><path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"/><path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/>'
    };
    return `<svg class="wgh-icon" width="${size || 16}" height="${size || 16}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${paths[name] || ''}</svg>`;
  };

  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  const cartBase = () => (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add').replace(/\/add$/, '');

  const dispatch = (name, detail) => {
    document.dispatchEvent(new CustomEvent(name, { bubbles: true, composed: true, detail: Object.assign({ sectionId: null }, detail || {}) }));
  };

  /* ---- Toast ----------------------------------------------------------- */
  function toastRegion() {
    let region = $('[data-wgh-toasts]');
    if (!region) {
      region = document.createElement('div');
      region.className = 'wgh-toast-region';
      region.setAttribute('data-wgh-toasts', '');
      region.setAttribute('aria-live', 'polite');
      document.body.appendChild(region);
    }
    return region;
  }
  function toast(title, detail, tone) {
    const region = toastRegion();
    const el = document.createElement('div');
    el.className = 'wgh-toast' + (tone === 'error' ? ' wgh-toast--error' : '');
    el.setAttribute('role', 'status');
    el.innerHTML = `${icon(tone === 'error' ? 'triangle-alert' : 'check', 16)}<div><div class="wgh-toast__title">${esc(title)}</div>${detail ? `<div class="wgh-toast__detail">${esc(detail)}</div>` : ''}</div><button class="wgh-toast__close" type="button" aria-label="Dismiss">${icon('x', 14)}</button>`;
    const remove = () => el.remove();
    el.querySelector('.wgh-toast__close').addEventListener('click', remove);
    region.appendChild(el);
    setTimeout(remove, 4000);
  }
  window.wghToast = toast;

  /* ---- Filters: form submits as a GET, so filters stay URL state -------- */
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-wgh-filter-input]');
    if (!input) return;
    const form = input.closest('form');
    if (!form) return;
    if (typeof form.requestSubmit === 'function') form.requestSubmit(); else form.submit();
  });
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-wgh-filter-form]');
    if (!form) return;
    // Drop empty fields so the URL stays clean (empty price bounds, unticked boxes).
    $$('input', form).forEach((i) => {
      if ((i.type === 'number' || i.type === 'text') && i.value === '') i.disabled = true;
    });
  });
  document.addEventListener('change', (e) => {
    const select = e.target.closest('[data-wgh-sort]');
    if (!select) return;
    const form = document.getElementById(select.getAttribute('data-form'));
    if (form) {
      let hidden = form.querySelector('input[name="sort_by"]');
      if (!hidden) {
        hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = 'sort_by';
        form.appendChild(hidden);
      }
      hidden.value = select.value;
      if (typeof form.requestSubmit === 'function') form.requestSubmit(); else form.submit();
    } else {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.assign(url.toString());
    }
  });

  /* facet open/closed memory */
  const facetState = store.get(FACET_KEY, true) || {};
  $$('[data-wgh-facet]').forEach((d) => {
    const id = d.getAttribute('data-wgh-facet');
    if (id in facetState) d.open = !!facetState[id];
    d.addEventListener('toggle', () => {
      facetState[id] = d.open;
      store.set(FACET_KEY, facetState, true);
    });
  });

  /* mobile filter drawer */
  const sidebar = $('[data-wgh-sidebar]');
  const backdrop = $('[data-wgh-sidebar-backdrop]');
  const openFilters = (open) => {
    if (!sidebar) return;
    sidebar.classList.toggle('is-open', open);
    if (backdrop) backdrop.hidden = !open;
    document.body.classList.toggle('wgh-filters-open', open);
    if (open) { const first = sidebar.querySelector('input, button, a'); first && first.focus(); }
  };
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-wgh-filters-open]')) openFilters(true);
    else if (e.target.closest('[data-wgh-filters-close]') || e.target.closest('[data-wgh-sidebar-backdrop]')) openFilters(false);
  });

  /* long facet lists: "Show all N" / "Show fewer" */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-wgh-facet-more]');
    if (!btn) return;
    const facet = btn.closest('[data-wgh-facet]');
    const expand = !facet.hasAttribute('data-expanded');
    facet.toggleAttribute('data-expanded', expand);
    btn.setAttribute('aria-expanded', expand ? 'true' : 'false');
    btn.textContent = btn.getAttribute(expand ? 'data-less' : 'data-more');
  });

  /* desktop sidebar, two-way sticky: a column taller than the viewport moves
     with the page until its last facet is in view, then holds; scrolling up
     moves it back down until its top sits under the sticky header. Shorter
     columns just stick under the header. Drives --wgh-sidebar-top. */
  if (sidebar && 'ResizeObserver' in window) {
    const desktop = window.matchMedia('(min-width: 901px)');
    const GAP = 16;
    let top = null;
    let lastY = window.scrollY;
    let queued = false;
    const headerBottom = () => {
      const header = $('.wgh-header-section--sticky');
      return header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
    };
    const place = () => {
      queued = false;
      const y = window.scrollY;
      if (!desktop.matches) {
        sidebar.style.removeProperty('--wgh-sidebar-top');
        top = null;
        lastY = y;
        return;
      }
      const max = headerBottom() + GAP;
      const min = Math.min(max, window.innerHeight - sidebar.offsetHeight - GAP);
      top = top === null ? max : top - (y - lastY);
      top = Math.max(min, Math.min(max, top));
      lastY = y;
      sidebar.style.setProperty('--wgh-sidebar-top', Math.round(top) + 'px');
    };
    const queue = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(place);
    };
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    new ResizeObserver(queue).observe(sidebar);
    place();
  }

  /* ---- Grid / spec-list view -------------------------------------------- */
  const cards = $('[data-wgh-cards]');
  const setView = (view) => {
    if (!cards) return;
    cards.classList.toggle('wgh-cards--list', view === 'list');
    $$('[data-wgh-view]').forEach((b) => b.setAttribute('aria-pressed', b.getAttribute('data-wgh-view') === view ? 'true' : 'false'));
  };
  if (cards) {
    setView(store.get(VIEW_KEY) || cards.getAttribute('data-default-view') || 'grid');
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-wgh-view]');
      if (!btn) return;
      const view = btn.getAttribute('data-wgh-view');
      store.set(VIEW_KEY, view);
      setView(view);
    });
  }

  /* ---- Cart ----------------------------------------------------------- */
  async function addToCart(btn) {
    const id = Number(btn.getAttribute('data-variant-id'));
    if (!id) return;
    btn.setAttribute('loading', '');
    btn.disabled = true;
    try {
      const res = await fetch(`${cartBase()}/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id, quantity: 1 }] })
      });
      if (!res.ok) {
        let msg = 'Could not add to cart.';
        try { const j = await res.json(); if (j && (j.description || j.message)) msg = j.description || j.message; } catch (err) { /* ignore */ }
        throw new Error(msg);
      }
      toast('Added to cart', btn.getAttribute('data-detail') || btn.getAttribute('data-title') || '');
      dispatch('updateCart', { callback: () => {} });
      const openDrawer = document.body.getAttribute('data-wgh-cart-action') === 'drawer';
      if (openDrawer) dispatch('openPopup', { target: 'CART' });
    } catch (err) {
      toast('Not added', err.message || 'Please try again.', 'error');
    } finally {
      btn.removeAttribute('loading');
      btn.disabled = false;
    }
  }
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-wgh-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    addToCart(btn);
  });

  /* ---- Quote list ----------------------------------------------------- */
  const quote = {
    read() { return store.get(QUOTE_KEY) || []; },
    write(items) { store.set(QUOTE_KEY, items); this.renderCount(); this.renderDialog(); },
    add(item) {
      const items = this.read();
      const found = items.find((i) => i.handle === item.handle && String(i.variant) === String(item.variant));
      if (found) found.qty = (found.qty || 1) + 1; else items.push(Object.assign({ qty: 1 }, item));
      this.write(items);
    },
    remove(index) { const items = this.read(); items.splice(index, 1); this.write(items); },
    setQty(index, qty) { const items = this.read(); if (items[index]) { items[index].qty = Math.max(1, qty | 0); this.write(items); } },
    count() { return this.read().reduce((n, i) => n + (i.qty || 1), 0); },
    renderCount() {
      const n = this.count();
      $$('[data-wgh-quote-count]').forEach((el) => { el.textContent = n; el.toggleAttribute('empty', n === 0); });
    },
    renderDialog() {
      const body = $('[data-wgh-quote-body]');
      if (!body) return;
      const items = this.read();
      const submit = $('[data-wgh-quote-submit]');
      if (submit) submit.disabled = items.length === 0;
      if (!items.length) {
        body.innerHTML = `<p class="wgh-qlist__empty">${esc(body.getAttribute('data-empty') || 'No line items yet. Add units from any collection or product page and we will rate the freight against your delivery site.')}</p>`;
        return;
      }
      body.innerHTML = `<ul class="wgh-qlist">${items.map((i, idx) => `
        <li>
          <div><div class="wgh-qlist__name"><a class="wgh-link-plain" href="${esc(i.url)}">${esc(i.title)}</a></div><div class="wgh-qlist__meta">${esc(i.vendor || '')}${i.sku ? ' · SKU ' + esc(i.sku) : ''}${i.price ? ' · ' + esc(i.price) : ''}</div></div>
          <label class="wgh-visually-hidden" for="wgh-qty-${idx}">Quantity</label>
          <input class="wgh-input wgh-qlist__qty" id="wgh-qty-${idx}" type="number" min="1" value="${i.qty || 1}" data-wgh-quote-qty="${idx}">
          <button class="wgh-qlist__remove" type="button" data-wgh-quote-remove="${idx}" aria-label="Remove ${esc(i.title)}">${icon('trash', 16)}</button>
        </li>`).join('')}</ul>
        <p class="wgh-body-sm" style="margin-top:16px;">Freight is rated once against your delivery ZIP and returned by email within 2 business hours. Nothing is charged until you approve the freight figure.</p>`;
    },
    summary() {
      return this.read().map((i) => `${i.qty || 1} × ${i.title}${i.sku ? ' (SKU ' + i.sku + ')' : ''}${i.vendor ? ' — ' + i.vendor : ''}`).join('\n');
    },
    submit() {
      const items = this.read();
      if (!items.length) return;
      const text = this.summary();
      const short = items.map((i) => `${i.qty || 1}× ${i.sku || i.title}`).join('; ');
      const dialog = $('[data-wgh-quote-dialog]');
      if (dialog && dialog.open) dialog.close();
      const partField = document.getElementById('Product_Part_Number');
      if (partField) partField.value = short;
      const body = document.querySelector('#RFQForm textarea[name="contact[body]"]');
      if (body && !body.value) body.value = `Quote request for:\n${text}\n\nDelivery details: `;
      const qty = document.querySelector('#RFQForm input[name="contact[quantity]"]');
      if (qty && !qty.value) qty.value = this.count();
      const proxy = document.createElement('button');
      proxy.type = 'button';
      proxy.dataset.text = short;
      proxy.hidden = true;
      document.body.appendChild(proxy);
      if (window.RFQPopup && typeof window.RFQPopup.open === 'function') window.RFQPopup.open(proxy);
      else if (typeof window.openRfqPopup === 'function') window.openRfqPopup(proxy);
      else window.location.hash = '#RFQForm';
      proxy.remove();
    }
  };
  window.wghQuote = quote;
  quote.renderCount();
  quote.renderDialog();

  document.addEventListener('click', (e) => {
    const add = e.target.closest('[data-wgh-quote-add]');
    if (add) {
      e.preventDefault();
      const card = add.closest('[data-wgh-card]');
      let data = null;
      try { data = card ? JSON.parse(card.getAttribute('data-compare')) : null; } catch (err) { data = null; }
      if (!data) return;
      quote.add({ handle: data.handle, url: data.url, title: data.title, sku: data.sku, vendor: data.vendor, price: data.price, variant: data.variant });
      toast('Added to quote', add.getAttribute('data-detail') || data.title);
      return;
    }
    const open = e.target.closest('[data-wgh-quote-open]');
    if (open) {
      e.preventDefault();
      const dialog = $('[data-wgh-quote-dialog]');
      if (dialog && typeof dialog.showModal === 'function') { quote.renderDialog(); dialog.showModal(); }
      return;
    }
    const remove = e.target.closest('[data-wgh-quote-remove]');
    if (remove) { quote.remove(Number(remove.getAttribute('data-wgh-quote-remove'))); return; }
    if (e.target.closest('[data-wgh-quote-submit]')) { e.preventDefault(); quote.submit(); return; }
    if (e.target.closest('[data-wgh-quote-clear]')) { quote.write([]); return; }
  });
  document.addEventListener('change', (e) => {
    const qty = e.target.closest('[data-wgh-quote-qty]');
    if (qty) quote.setQty(Number(qty.getAttribute('data-wgh-quote-qty')), Number(qty.value));
  });

  /* ---- Compare (up to 4, survives navigation) --------------------------- */
  const compare = {
    read() { return store.get(COMPARE_KEY) || []; },
    write(items) { store.set(COMPARE_KEY, items); this.render(); },
    has(handle) { return this.read().some((i) => i.handle === handle); },
    toggle(data) {
      const items = this.read();
      const idx = items.findIndex((i) => i.handle === data.handle);
      if (idx >= 0) items.splice(idx, 1);
      else if (items.length < MAX_COMPARE) items.push(data);
      else { toast('Compare is full', `Remove one of the ${MAX_COMPARE} selected units first.`, 'error'); return; }
      this.write(items);
    },
    remove(handle) { this.write(this.read().filter((i) => i.handle !== handle)); },
    render() {
      const items = this.read();
      const full = items.length >= MAX_COMPARE;
      $$('[data-wgh-card]').forEach((card) => {
        const handle = card.getAttribute('data-handle');
        const on = items.some((i) => i.handle === handle);
        card.classList.toggle('wgh-pcard--compared', on);
        const box = card.querySelector('[data-wgh-compare]');
        if (box) {
          box.checked = on;
          box.disabled = full && !on;
          const label = box.closest('.wgh-pcard__compare');
          if (label) label.classList.toggle('wgh-pcard__compare--disabled', full && !on);
        }
      });
      const tray = $('[data-wgh-ctray]');
      if (!tray) return;
      tray.hidden = items.length === 0;
      document.body.classList.toggle('wgh-has-tray', items.length > 0);
      const count = $('[data-wgh-ctray-count]');
      if (count) count.textContent = items.length;
      const list = $('[data-wgh-ctray-items]');
      if (list) list.innerHTML = items.map((i) => `<button class="wgh-tag wgh-tag--inverse" type="button" data-wgh-compare-remove="${esc(i.handle)}" aria-label="Remove ${esc(i.title)} from compare">${esc(i.vendor ? i.vendor + ' ' : '')}${esc(i.sku || i.title)} ${icon('x', 12)}</button>`).join('');
      const openBtn = $('[data-wgh-compare-open]');
      if (openBtn) openBtn.disabled = items.length < 2;
    },
    openDialog() {
      const dialog = $('[data-wgh-compare-dialog]');
      const body = $('[data-wgh-compare-body]');
      if (!dialog || !body) return;
      const items = this.read();
      const n = $('[data-wgh-compare-n]');
      if (n) n.textContent = items.length;
      // Spec rows: the union of every unit's labels, in first-seen order.
      const labels = [];
      items.forEach((i) => (i.specs || []).forEach(([l]) => { if (!labels.includes(l)) labels.push(l); }));
      const specOf = (i, l) => { const r = (i.specs || []).find(([k]) => k === l); return r ? r[1] : '—'; };
      const rows = [
        ['Brand', (i) => i.vendor || '—', true],
        ['SKU', (i) => i.sku || '—'],
        ...labels.map((l) => [l, (i) => specOf(i, l)]),
        ['Standard cited', (i) => i.std || '—', true],
        ['Freight', (i) => i.freight || '—'],
        ['Availability', (i) => i.stock || '—'],
        ['Price', (i) => i.price || '—']
      ];
      body.innerHTML = `<table class="wgh-cmp"><thead><tr><th></th>${items.map((i) => `<th><a class="wgh-pcard__title-link" href="${esc(i.url)}">${esc(i.title)}</a></th>`).join('')}</tr></thead><tbody>${rows.map(([label, fn, text]) => `<tr><td>${esc(label)}</td>${items.map((i) => `<td${text ? ' class="wgh-cmp__text"' : ''}>${esc(fn(i))}</td>`).join('')}</tr>`).join('')}</tbody></table>`;
      if (typeof dialog.showModal === 'function') dialog.showModal();
    }
  };
  window.wghCompare = compare;
  compare.render();

  document.addEventListener('change', (e) => {
    const box = e.target.closest('[data-wgh-compare]');
    if (!box) return;
    const card = box.closest('[data-wgh-card]');
    let data = null;
    try { data = JSON.parse(card.getAttribute('data-compare')); } catch (err) { data = null; }
    if (!data) return;
    compare.toggle(data);
  });
  document.addEventListener('click', (e) => {
    const rm = e.target.closest('[data-wgh-compare-remove]');
    if (rm) { compare.remove(rm.getAttribute('data-wgh-compare-remove')); return; }
    if (e.target.closest('[data-wgh-compare-clear]')) { compare.write([]); return; }
    if (e.target.closest('[data-wgh-compare-open]')) { compare.openDialog(); return; }
    if (e.target.closest('[data-wgh-compare-quote]')) {
      compare.read().forEach((i) => quote.add({ handle: i.handle, url: i.url, title: i.title, sku: i.sku, vendor: i.vendor, price: i.price, variant: i.variant }));
      const dialog = $('[data-wgh-compare-dialog]');
      if (dialog && dialog.open) dialog.close();
      toast('Added to quote', `${compare.read().length} units added. Freight is rated once against your delivery ZIP.`);
      return;
    }
    const close = e.target.closest('[data-wgh-dialog-close]');
    if (close) { const d = close.closest('dialog'); if (d) d.close(); }
  });
  // click on the backdrop closes a dialog
  $$('dialog.wgh-dialog').forEach((d) => {
    d.addEventListener('click', (e) => { if (e.target === d) d.close(); });
  });

  /* ---- Brand index: client-side filter over the rendered cards ---------- */
  const bindex = $('[data-wgh-bindex]');
  if (bindex) {
    const cardsB = $$('[data-wgh-bcard]', bindex);
    const empty = $('[data-wgh-bindex-empty]', bindex);
    const state = { cat: 'all', auth: false, q: '' };
    const apply = () => {
      let shown = 0;
      cardsB.forEach((c) => {
        const cats = (c.getAttribute('data-cats') || '').toLowerCase();
        const text = (c.getAttribute('data-text') || '').toLowerCase();
        const authorized = c.getAttribute('data-relationship') === 'authorized';
        const okCat = state.cat === 'all' || cats.includes(state.cat);
        const okAuth = !state.auth || authorized;
        const okQ = !state.q || text.includes(state.q);
        const show = okCat && okAuth && okQ;
        c.hidden = !show;
        if (show) shown++;
      });
      if (empty) empty.hidden = shown > 0;
    };
    bindex.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-wgh-bcat]');
      if (!btn) return;
      state.cat = btn.getAttribute('data-wgh-bcat').toLowerCase();
      $$('[data-wgh-bcat]', bindex).forEach((b) => b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'));
      apply();
    });
    bindex.addEventListener('change', (e) => {
      if (e.target.matches('[data-wgh-bauth]')) { state.auth = e.target.checked; apply(); }
    });
    bindex.addEventListener('input', (e) => {
      if (e.target.matches('[data-wgh-bsearch]')) { state.q = e.target.value.trim().toLowerCase(); apply(); }
    });
  }
})();
